import { scenes } from "../scenes";
import { Scene, Choice } from "../models";

const exterior = require("@/images/Vincent_Sonnys_House.png");

export class HouseExterior extends Scene {
  timesVisited = 0;
  title = "Sonny's House";
  image = exterior;

  description = "";

  get options(): any[] {
    return [
      new Choice("Enter Sonny’s House ", async () => {
        if (this.state.storylines.findSupermarket) {
          this.description =
            "SONNY YANG : I’m not heading back inside until I’ve acquired the necessary supplies.";
          this.audio = require("@/audio/Pandemic_6_Sonny-MP3.mp3");
        } else {
          await this.navigate(scenes.LivingRoom());
        }
      }),
      new Choice("Go Left", async () => {
        if (this.state.storylines.findSupermarket) {
          this.description =
            "SONNY YANG: The Supermarket is in the other direction.";
          this.audio = require("@/audio/Pandemic_7_Sonny-MP3.mp3");
        } else {
          await this.navigate(scenes.BelovedOldPub());
        }
      }),
      new Choice("Go Right", async () => {
        await this.navigate(scenes.Supermarket());
      }),
    ];
  }
}

export default new HouseExterior();
